/**
 * Created by Karan variya on 22/12/2018.
 */
import { Injectable } from '@angular/core'
@Injectable()
export class ApiConstant {
    // public MainUrl: string = 'https://phoenixhealthcoach.com/';
    // public Server: string = 'http://192.168.0.101:7850/';// for admin
    // public Server2: string = 'http://192.168.0.101:7850/';//for mobile user
    // public BaseUrl: string = 'http://192.168.0.101/';
    // public DatabaseUrl: string = 'http://192.168.0.101:7850/';

    // public MainUrl: string = 'https://phoenixhealthcoach.com/';
    // public Server: string = 'http://192.168.0.101:7854/';// for admin
    // public Server2: string = 'http://192.168.0.101:7854/';//for mobile user
    // public BaseUrl: string = 'http://192.168.0.101/';
    // public DatabaseUrl: string = 'http://192.168.0.101:7854/';
    
    // public MainUrl: string = 'https://phoenixhealthcoach.com/';
    // public Server: string = 'https://testapi.phoenixhealthcoach.com:7854/';// for admin
    // public Server2: string = 'https://testapi.phoenixhealthcoach.com:7854/';//for mobile user
    // public BaseUrl: string = 'https://testapi.phoenixhealthcoach.com/';
    // public DatabaseUrl: string = 'https://testapi.phoenixhealthcoach.com/';

    public MainUrl: string = 'https://phoenixhealthcoach.com/';
    public Server: string = 'https://api.phoenixhealthcoach.com:7850/';// for admin
    public Server2: string = 'https://api.phoenixhealthcoach.com:7850/';//for mobile user
    public BaseUrl: string = 'https://api.phoenixhealthcoach.com/';
    public DatabaseUrl: string = 'https://api.phoenixhealthcoach.com/';

    public blogurl: string = "https://phoenixhealthcoach.com/blogdetail/"
    public blogimageurl: string = "https://api.phoenixhealthcoach.com/uploads/blogimage/"
    public ApiUrl: string = 'v2/general/';
    public ServerWithApiUrl = this.Server + this.ApiUrl;
    public ServerWithApiUrlreplace = this.Server2 + this.ApiUrl;
    public crypto_password: string = 'XtjDjBL2Q5QIX1GVIzJk2nItU29RnTti';
    public imageurlportfolio: string = this.BaseUrl + "uploads/portfolio/";

    public isChatAPICall : boolean = false;
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/api.constant.ts